import { GridContainer } from '@bob/library'
import { UniqueSellingPoints } from '@websrc/App/Components/UniqueSellingPoints/UniqueSellingPoints'
import { mapUniqueSellingPoints } from '@websrc/DataMappers/mapSpot'
import React from 'react'

import { LearnMoreButtonType } from '../Collapse/SpotCollapse'

interface SpotUniqueSellingPointsProps {
  spot: ReturnType<typeof mapUniqueSellingPoints>
  LearnMoreButton?: LearnMoreButtonType
  isTopOfPage?: boolean
}

export const SpotUniqueSellingPoints: React.FC<SpotUniqueSellingPointsProps> = ({
  spot,
  LearnMoreButton,
  isTopOfPage,
}) => {
  const LearnMore = LearnMoreButton && <LearnMoreButton position={[spot.headline]} />

  return (
    <GridContainer>
      <UniqueSellingPoints {...spot} cta={LearnMore} isTopOfPage={isTopOfPage} />
    </GridContainer>
  )
}
